import type { TiptapCollabProvider } from '@tiptap-pro/provider';
import { Observable } from 'rxjs';

export function fromProviderEvent<T = void>(provider: TiptapCollabProvider, event: string): Observable<T> {
  return new Observable<T>((subscriber) => {
    const handler = (data: T) => subscriber.next(data);
    provider.on(event, handler);
    return () => provider.off?.(event, handler);
  });
}
